angular.module('zc.zenclerkS')
  .controller('ZcsAgencyInvoiceShowController', ZcsAgencyInvoiceShowController);

ZcsAgencyInvoiceShowController.$inject = ['$state', '$stateParams', '$translate', 'agency', 'currencies', 'invoice', 'projects'];
function ZcsAgencyInvoiceShowController($state, $stateParams, $translate, agency, currencies, invoice, projects) {
  //# Set values
  const vm = this;
  vm.agency = agency;
  vm.invoice = invoice;
  vm.invoiceCurrency = currencies[invoice.invoice_currency || 'jpy'];

  const projectByApikey = {};
  for(let project of projects) {
    projectByApikey[project.apikey] = project;
  }
  for(let site of vm.invoice.sites) {
    const currentProject = projectByApikey[site.apikey];
    site.title = currentProject ? currentProject.title : site.apikey;
  }

  //# Get the selected month
  const currentMonth = moment($stateParams.term, 'YYYY-MM').endOf('month');
  vm.invoiceMonth = $stateParams.term;

  vm.currentMonth = currentMonth.format('YYYY/MM');

  vm.header = [
    'APIKEY',
    $translate.instant('agencies.invoices.showController.saito_na'),
    $translate.instant('agencies.invoices.showController.himoku'),
    $translate.instant('agencies.invoices.showController.seikyuu_kingaku_zeinuki'),
    $translate.instant('agencies.invoices.showController.dairiten_tesuuryou_zeinuki'),
    $translate.instant('agencies.invoices.showController.seikyuu_kingaku_dairiten'),
    $translate.instant('agencies.invoices.showController.note_sum')
  ];

  vm.isLatest = isLatest;
  vm.goToNext = goToNext;
  vm.nextMonth = moment(currentMonth).add(1, 'months').format('YYYY-MM');
  vm.lastMonth = moment(currentMonth).subtract(1, 'months').format('YYYY-MM');
  vm.getCSV = getCSV;


  function isLatest() {
    if(moment(currentMonth).isAfter(moment())) {
      return true;
    }
    return false;
  }

  function goToNext(term) {
    if(vm.isLatest()) {
      return;
    }
    $state.go('zenclerkS.agency.invoices.show', {term});
  }

  function getCSV() {
    const resultData = [];
    _.each(vm.invoice.sites, site => {
      _.each(site.details, detail => {
        const data = [
          site.apikey,
          site.title,
          detail.title,
          detail.original_price,
          detail.original_price - detail.price,
          detail.price
        ];
        resultData.push(data);
      });
    });
    return resultData;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/invoices/agency_invoice_show.controller.js